import { render, staticRenderFns } from "./CantCreateMore.vue?vue&type=template&id=02079763&"
import script from "./CantCreateMore.vue?vue&type=script&lang=js&"
export * from "./CantCreateMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports